var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"animation","appear":"","mode":"out-in"}},[(_vm.showLeft)?_c('p',{key:"1"},[_vm._v(_vm._s(_vm.hint1))]):_c('p',{key:"2"},[_vm._v(_vm._s(_vm.hint2))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }